module.exports = __webpack_public_path__ + "img/20240401081300540ee5.7b00e9b6.jpg";